module.exports = __webpack_public_path__ + "media/images/email/rewards/trophy-dc3544f64371b8ed32019a5513468c69.png";